import {
  MagnifyingGlassCircleIcon,
  Cog6ToothIcon,
  ChartBarSquareIcon,
  BoltIcon,
  ComputerDesktopIcon,
  CircleStackIcon,
  LightBulbIcon,
  HomeIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ShieldCheckIcon,
  TrophyIcon,
  RocketLaunchIcon,
  BuildingOffice2Icon,
  ClockIcon,
  StarIcon,
  BriefcaseIcon,
  ArrowRightIcon,
  XMarkIcon,
  InformationCircleIcon,
  CpuChipIcon,
  ServerIcon,
  CodeBracketIcon,
  LinkIcon,
  GlobeAltIcon,
  PlayCircleIcon,
  SignalIcon,
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  ArrowPathIcon,
  CloudIcon,
  ChartBarIcon,
  CubeIcon,
  CommandLineIcon,
  WifiIcon,
} from '@heroicons/react/24/outline';

export const TECH_ICONS = {
  analysis: MagnifyingGlassCircleIcon,
  standardization: Cog6ToothIcon,
  erp: ChartBarSquareIcon,
  automation: BoltIcon,
  web: ComputerDesktopIcon,
  database: CircleStackIcon,
  consulting: LightBulbIcon,
  home: HomeIcon,
  team: UserGroupIcon,
  services: WrenchScrewdriverIcon,
  chat: ChatBubbleLeftRightIcon,
  check: CheckCircleIcon,
  shield: ShieldCheckIcon,
  trophy: TrophyIcon,
  rocket: RocketLaunchIcon,
  building: BuildingOffice2Icon,
  clock: ClockIcon,
  star: StarIcon,
  projects: BriefcaseIcon,
  'arrow-right': ArrowRightIcon,
  close: XMarkIcon,
  info: InformationCircleIcon,
  cpu: CpuChipIcon,
  server: ServerIcon,
  code: CodeBracketIcon,
  link: LinkIcon,
  globe: GlobeAltIcon,
  play: PlayCircleIcon,
  signal: SignalIcon,
  mobile: DevicePhoneMobileIcon,
  document: DocumentTextIcon,
  sync: ArrowPathIcon,
  cloud: CloudIcon,
  chart: ChartBarIcon,
  cube: CubeIcon,
  terminal: CommandLineIcon,
  wifi: WifiIcon,
  mission: RocketLaunchIcon,
  vision: GlobeAltIcon,
  excellence: TrophyIcon,
  integrity: ShieldCheckIcon,
  innovation: LightBulbIcon,
  benefits: ChartBarIcon,
  duration: ClockIcon,
  features: CpuChipIcon,
  whatsapp: ChatBubbleLeftRightIcon,
  facebook: GlobeAltIcon,
  twitter: SignalIcon,
  linkedin: BuildingOffice2Icon,
  instagram: DevicePhoneMobileIcon,
  youtube: PlayCircleIcon,
};

const TechIcon = ({ name, className = 'w-6 h-6', ...props }) => {
  const Icon = TECH_ICONS[name];
  if (!Icon) return null;
  return <Icon className={className} aria-hidden {...props} />;
};

export default TechIcon;
